import { GenIcon } from "../iconBase";

export function GrNext(props) {
    return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "polyline", "attr": { "fill": "none", "stroke": "#000", "strokeWidth": "2", "points": "7 2 17 12 7 22" } }] })(props);
};